import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import axios from "axios";
import config from "../../../config.json";
import {Paper, Button, Typography, TextField, InputLabel, Select, MenuItem, FormControl} from "@material-ui/core";
import {DeleteOutline} from '@material-ui/icons';
import {partnerService} from "../../../services/PartnerService";
import {INotificacion} from "../../../types";


const tiposUsuario: Record<number, string> = {
    1: "Avanzado",
    2: "Profesional"
}


interface IProps {
    nuevaPromocion: boolean
    notify(notification: INotificacion): void
}

interface Istate {
    promociones: Record<string, string|number>[]
    borrar: string
}


class Promociones extends React.Component<IProps, Istate> {

    state:Istate = {
        promociones: [] as Record<string, string|number>[],
        borrar: ''
    }

    componentDidMount() {
        axios.get(config.url+'/promociones')
            .then((res) => {
                this.setState({promociones: res.data})
            })
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.nuevaPromocion && !nextProps.nuevaPromocion) this.componentDidMount()
        return true
    }

    handleBorrar = (codigo: string) => {
        axios.get(
            config.url+`/delete/promocion?codigo=${codigo}`,
            {auth: {
                    username: `${partnerService.getUser()}`,
                    password: `${partnerService.getPass()}`
                }})
            .then(() => {
                this.props.notify({message: "Promocion borrada correctamente", variant: 'success'})
                this.componentDidMount()
            })
            .catch(() => {
                this.props.notify({message: "Error interno", variant: 'error'})
            })
    }

    renderPromociones = () => {
        return (
            this.state.promociones.map((promocion) =>
                <Paper
                    key={promocion["codigo"]}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "fit-content",
                        height: "fit-content",
                        margin: 10
                    }}
                >
                    <link rel="stylesheet"
                          href="https://fonts.googleapis.com/css?family=Poppins"
                    />
                    <TextField
                        style={{
                            marginTop: 40,
                            marginLeft: 40,
                            marginRight: 40,
                            width: 250,
                            fontFamily: "Poppins"
                        }}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                        value={promocion.codigo}
                        label={"Código de la promoción"}
                    />

                    <TextField
                        style={{
                            marginTop: 40,
                            marginLeft: 40,
                            marginRight: 40,
                            width: 250,
                            fontFamily: "Poppins"
                        }}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                        value={promocion.fecha_expiracion}
                        label={"Fecha expiración"}
                    />

                    <TextField
                        style={{
                            marginTop: 40,
                            marginLeft: 40,
                            marginRight: 40,
                            width: 250,
                            fontFamily: "Poppins"
                        }}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                        value={tiposUsuario[promocion.tipo_usuario as number]}
                        label={"Tipo de Usuario"}
                    />

                    <TextField
                        style={{
                            marginTop: 20,
                            marginLeft: 40,
                            marginRight: 40,
                            width: 250
                        }}
                        value={promocion.superficie}
                        placeholder={"Superficie (Ha)"}
                        label={"Superficie (Ha)"}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                    />

                    <TextField
                        style={{
                            marginTop: 20,
                            marginLeft: 40,
                            marginRight: 40,
                            width: 250
                        }}
                        value={promocion.parcelas}
                        placeholder={"#Parcelas"}
                        label={"#Parcelas"}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                    />

                    <TextField
                        style={{
                            marginTop: 20,
                            marginLeft: 40,
                            marginRight: 40,
                            width: 250
                        }}
                        value={promocion.duracion}
                        placeholder={"Duración (meses)"}
                        label={"Duración (meses)"}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                    />

                    <TextField
                        style={{
                            marginTop: 20,
                            marginLeft: 40,
                            marginRight: 40,
                            width: 250
                        }}
                        value={promocion.precio}
                        placeholder={"Precio €"}
                        label={"Precio €"}
                        inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                        InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                    />

                    {this.state.borrar !== promocion.codigo &&
                        <Button
                            style={{
                                margin: 40,
                                width: 250,
                                textTransform: "none"
                            }}
                            variant={"outlined"}
                            onClick={() => this.setState({borrar: promocion.codigo as string})}
                        >

                            <DeleteOutline style={{marginRight: 10, color: "#c73636"}}/>
                            <Typography
                                style={{fontSize: 18, fontFamily: "Poppins"}}
                            >
                                Borrar
                            </Typography>

                        </Button>
                    }

                    {this.state.borrar === promocion.codigo &&
                        <div
                            style={{
                                margin: 40,
                                width: 250,
                                textTransform: "none",
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            <Typography
                                style={{
                                    fontSize: 16,
                                    fontFamily: "Poppins"
                                }}
                            >
                                ¿Estás seguro de que quieres Borrar la promoción?
                            </Typography>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "100%",
                                    justifyContent: "space-around"
                                }}
                            >
                                <Button
                                    style={{
                                        margin: 40,
                                        width: 250,
                                        textTransform: "none"
                                    }}
                                    variant={"outlined"}
                                    onClick={() => this.handleBorrar(promocion.codigo as string)}
                                >
                                    <Typography
                                        style={{
                                            fontSize: 16,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        Sí
                                    </Typography>
                                </Button>

                                <Button
                                    style={{
                                        margin: 40,
                                        width: 250,
                                        textTransform: "none"
                                    }}
                                    variant={"outlined"}
                                    onClick={() => this.setState({borrar: ""})}
                                >
                                    <Typography
                                        style={{
                                            fontSize: 16,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        No
                                    </Typography>
                                </Button>
                            </div>

                        </div>
                    }

                </Paper>
            )
        )
    }

    render() {

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%',
                    backgroundColor: "#ECECEC"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        width: 'calc(100% - 100px)',
                        height: "fit-content",
                        maxHeight: 'calc(100% - 60px)',
                        marginRight: 50,
                        marginLeft: 50,
                        marginTop: 30,
                        marginBottom: 30,
                        overflowY: "auto"
                    }}
                >
                    {this.renderPromociones()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    nuevaPromocion: state.navegacionPartners.dialogs.crea_promocion
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify-partners', notification})
});

export default connect(mapStateToProps, mapDispatchToProps)(Promociones);
